export default __webpack_public_path__ + "static/media/team__item-img-1.d16c7ae7.jpg";